import useTheme from "@/hooks/useTheme";

// Every color any Kalkulator surface needs, keyed by theme — shared by the builder dialog
// AND the admin master-data editor so both read from the exact same tokens instead of each
// hardcoding its own palette (that drift is what left the master-data page still black in
// light mode after the builder dialog was already fixed). A CSS stylesheet rule can never
// win against a component's own inline/class-literal color, so every surface must read from
// this object instead of a literal.
export default function useKalkulatorPalette() {
  const theme = useTheme();
  const light = theme === "light";
  return light ? {
    light: true,
    dialogBg: "#ffffff", text: "#18181B", muted: "#71717A", faint: "#A1A1AA",
    card: "#FAFAFA", cardHd: "#F4F4F5", border: "#E4E4E7", borderSoft: "#EEEEF0",
    input: "#FFFFFF", inputBorder: "#D4D4D8", inputFocus: "#71717A",
    pillBg: "#F4F4F5", pillBorder: "#D4D4D8", pillText: "#3F3F46", pillHover: "#E4E4E7",
    sidebarGrad: "linear-gradient(155deg, #FAFAFA 0%, #F0F0F2 55%, #E4E4E7 100%)",
    sidebarBorder: "#E4E4E7", sidebarText: "#18181B", sidebarMuted: "#71717A",
    sidebarBoxBg: "rgba(0,0,0,.035)", sidebarDivider: "rgba(0,0,0,.08)",
    silverBtnGrad: "linear-gradient(135deg, #27272A 0%, #3F3F46 60%, #52525B 100%)", silverBtnText: "#FFFFFF",
    ghostBtnBg: "#F4F4F5", ghostBtnBorder: "#D4D4D8", ghostBtnText: "#3F3F46",
    warnBg: "rgba(217,119,6,.08)", warnBorder: "rgba(217,119,6,.25)", warnText: "#B45309", warnIcon: "#D97706",
    discBg: "rgba(217,119,6,.06)", discBorder: "rgba(217,119,6,.2)",
    roomIdxGrad: "linear-gradient(135deg,#3F3F46,#18181B)", roomIdxText: "#FFFFFF",
  } : {
    light: false,
    dialogBg: "#0a0a0c", text: "#E4E4E7", muted: "#A1A1AA", faint: "#71717A",
    card: "#111114", cardHd: "rgba(255,255,255,.03)", border: "rgba(255,255,255,.1)", borderSoft: "rgba(255,255,255,.05)",
    input: "#18181B", inputBorder: "rgba(255,255,255,.1)", inputFocus: "#a1a1aa",
    pillBg: "rgba(255,255,255,.04)", pillBorder: "rgba(255,255,255,.15)", pillText: "#D4D4D8", pillHover: "rgba(255,255,255,.1)",
    sidebarGrad: "linear-gradient(155deg, #1c1c1f 0%, #131315 60%, #0a0a0b 100%)",
    sidebarBorder: "rgba(255,255,255,.1)", sidebarText: "#FFFFFF", sidebarMuted: "#A1A1AA",
    sidebarBoxBg: "rgba(255,255,255,.05)", sidebarDivider: "rgba(255,255,255,.1)",
    silverBtnGrad: "linear-gradient(135deg, #f4f4f5 0%, #d4d4d8 60%, #a1a1aa 100%)", silverBtnText: "#18181b",
    ghostBtnBg: "rgba(255,255,255,.05)", ghostBtnBorder: "rgba(255,255,255,.1)", ghostBtnText: "#E4E4E7",
    warnBg: "rgba(245,158,11,.04)", warnBorder: "rgba(245,158,11,.15)", warnText: "rgba(252,211,151,.8)", warnIcon: "rgba(251,191,36,.7)",
    discBg: "rgba(245,158,11,.05)", discBorder: "rgba(245,158,11,.2)",
    roomIdxGrad: "linear-gradient(135deg,#e4e4e7,#a1a1aa)", roomIdxText: "#18181b",
  };
}
